import { formatePhoneNumber } from '../../../../utils/supportFunctions';
import deburr from 'lodash/deburr';

function createData(membershipDB_id, membershipID, name, email, phone, registrationDate, status) {
  return {
    membershipDB_id,
    membershipID,
    name,
    email,
    phone,
    registrationDate,
    status,
  };
}

const normalizeSearchValue = (value) => deburr(String(value || '').trim()).toLowerCase();

const getFamilyMemberName = (familyMember) => (
  `${familyMember.firstName || ''} ${familyMember.lastName || ''}`.trim()
);

export const familyMemberMembershipCard = function (familyMemberArray, searchItem) {
  const inputValue = normalizeSearchValue(searchItem);
  for (let i = 0; i < familyMemberArray.length; i++) {
    if (familyMemberArray[i].membershipCard) {
      if (normalizeSearchValue(familyMemberArray[i].membershipCard).includes(inputValue)) {
        return familyMemberArray[i];
      }
    }
  }
  return null;
};

const searchFamilyMembers = (member, inputValue) => {
  for (let i = 0; i < member.familyMembersInformation.length; i++) {
    const familyMember = member.familyMembersInformation[i];
    if (normalizeSearchValue(getFamilyMemberName(familyMember)).includes(inputValue)) {
      return familyMember;
    }
  }
  return null;
};

const searchByEmail = (member, inputValue) => {
  if (!member.email) return false;
  return normalizeSearchValue(member.email).includes(inputValue);
};

export const getMembershipSearchMatch = (membershipData, searchItem) => {
  const inputValue = normalizeSearchValue(searchItem);
  if (!inputValue || !membershipData.familyMembersInformation[0]) return null;

  const member = membershipData.familyMembersInformation[0];
  const matchedFamilyMember = searchFamilyMembers(membershipData, inputValue);

  if (matchedFamilyMember) {
    return matchedFamilyMember;
  }

  if (searchByEmail(membershipData, inputValue)) return member;
  if (normalizeSearchValue(formatePhoneNumber(member.phone || '')).includes(inputValue)) return member;
  if (normalizeSearchValue(member.membershipID).includes(inputValue)) return member;

  return familyMemberMembershipCard(membershipData.familyMembersInformation, searchItem);
};

export const searchMembers = (membershipData, searchItem) => {
  return Boolean(getMembershipSearchMatch(membershipData, searchItem));
};

export const changeStatus = (membershipData) => {
  const membershipDate = new Date(membershipData.expirationDate);
  const todayDate = new Date();
  const endDate = new Date();
  endDate.setDate(endDate.getDate() + 30);
  if (membershipData.status === 'Unverified') {
    return 'Unverified';
  }
  if (membershipDate > todayDate && membershipDate < endDate) {
    return 'Expiring';
  }
  if (membershipDate < todayDate) {
    return 'Expired';
  }
  return 'Active';
};

export const pushMembershipResults = (rows, membershipData, searchItem = '') => {
  // if (membershipData.familyMembersInformation[0] === undefined) {
  //   console.log(membershipData);
  // }
  if (membershipData.familyMembersInformation[0]) {
    const selectedMember = searchItem
      ? getMembershipSearchMatch(membershipData, searchItem)
      : membershipData.familyMembersInformation[0];

    if (!selectedMember) return null;

    const rowKey = `${membershipData.membershipID}-${getFamilyMemberName(selectedMember)}-${membershipData.email || ''}`;
    const hasRow = rows.some((row) => (
      `${row.membershipID}-${row.name}-${row.email || ''}` === rowKey
    ));

    if (hasRow) return null;

    return rows.push(
      createData(
        membershipData._id,
        membershipData.membershipID,
        getFamilyMemberName(selectedMember),
        membershipData.email,
        selectedMember.phone,
        membershipData.registrationDate,
        changeStatus(membershipData)
      )
    );
  }
  return null;
};
